import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalLayout from './LegalLayout';
import { privacyPolicy } from './legalContent';
import Seo from '../../components/Seo';

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();
  const lang = ['fr', 'en', 'nl'].includes(i18n.language) ? i18n.language : 'fr';
  const content = privacyPolicy[lang];

  const breadcrumbLabel = { fr: 'Accueil', en: 'Home', nl: 'Home' }[lang];
  const otherLabel = {
    fr: 'Mentions légales',
    en: 'Legal Notice',
    nl: 'Wettelijke vermeldingen',
  }[lang];

  return (
    <>
      <Seo title={t('seo.privacy.title')} description={t('seo.privacy.desc')} noIndex />
      <LegalLayout
        content={content}
        breadcrumbLabel={breadcrumbLabel}
        otherLinkTo="/mentions-legales"
        otherLinkLabel={otherLabel}
        testIdPrefix="privacy-policy"
      />
    </>
  );
};

export default PrivacyPolicy;
